export default "__VITE_ASSET__CJooXgvi__"